import { render, staticRenderFns } from "./ReviewTable.vue?vue&type=template&id=e7c6632c&scoped=true&"
import script from "./ReviewTable.vue?vue&type=script&lang=js&"
export * from "./ReviewTable.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTable.vue?vue&type=style&index=0&id=e7c6632c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c6632c",
  null
  
)

export default component.exports